import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-e-commerce-digital-marketing-enhancing',
  templateUrl: './e-commerce-digital-marketing-enhancing.component.html',
  styleUrls: ['./e-commerce-digital-marketing-enhancing.component.scss']
})
export class ECommerceDigitalMarketingEnhancingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
